import React from "react";

import styles from "./separator.module.css";

export default function Separator() {
  return <div className={styles.separator} />;
}
